<main class="content">
  <app-ficha-etapas-cadastro
    titulo="Cadastrar Nova Ficha"
    [etapas]="etapas"
    [etapaAtual]="etapaAtual"
  ></app-ficha-etapas-cadastro>

  <section class="etapas">
    <div class="breadcrumb-wrapper">
      <app-breadcrumb
        [currentPage]="currentPageBreadcrumb"
        [currentPageDetail]="etapaAtual.descricao"
        voltar="hide"
        routerCurrentPage="/nova"
      >
      </app-breadcrumb>

      <div
        class="buttons"
        *ngIf="numeroEtapaAtual === 2 && !isClienteNaoElegivel"
      >
        <button class="btn btn-border-orange" (click)="excluirProposta()">
          <i class="fa fa-trash"></i>
          Excluir simulação
        </button>
      </div>
    </div>

    <app-resumo-financiamento
      *ngIf="numeroEtapaAtual >= 4 && numeroEtapaAtual <= 6"
    >
    </app-resumo-financiamento>

    <app-dados-simulacao
      *ngIf="numeroEtapaAtual === 1"
      [parametroRendaProduto]="parametroRendaProduto"
      [operacoes]="operacoes"
      [tabelas]="tabelas"
      (next)="onClickNext()"
    >
    </app-dados-simulacao>

    <app-cliente-nao-elegivel
      *ngIf="numeroEtapaAtual === 2 && isClienteNaoElegivel"
    ></app-cliente-nao-elegivel>

    <app-simulacao
      *ngIf="numeroEtapaAtual === 2 && !isClienteNaoElegivel"
      [tabelas]="tabelas"
      [parametroRendaProduto]="parametroRendaProduto"
      (next)="onClickNext()"
      (previous)="onClickPrevious()"
    >
    </app-simulacao>

    <app-dados-contato
      *ngIf="numeroEtapaAtual === 3"
      (previous)="onClickPrevious()"
    >
    </app-dados-contato>

    <app-dados-cliente
      *ngIf="numeroEtapaAtual === 4"
      (next)="onClickNext()"
      [parametroRendaProduto]="parametroRendaProduto"
    >
    </app-dados-cliente>

    <app-enderecos-cliente
      *ngIf="numeroEtapaAtual === 5"
      (next)="onClickNext()"
      (previous)="onClickPrevious()"
    >
    </app-enderecos-cliente>

    <app-demais-dados
      *ngIf="numeroEtapaAtual === 6"
      (next)="onClickNext()"
      (previous)="onClickPrevious()"
    >
    </app-demais-dados>

    <app-analise *ngIf="numeroEtapaAtual === 7"> </app-analise>

    <app-botao-navegacao
      *ngIf="etapaNaoPossuiControleIndependente()"
      (next)="onClickNext()"
      [previousShow]="false"
      [nextShow]="true"
      [nextLabel]="'Continuar'"
    ></app-botao-navegacao>
  </section>
</main>
<app-new-modal-message #dialog [showFecharBtn]="false"></app-new-modal-message>

<app-loader-circles *ngIf="showLoader"></app-loader-circles>
